module.exports = __webpack_public_path__ + "img/3.185d1d7c.png";